import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bbabf9ae&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=bbabf9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbabf9ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbabf9ae')) {
      api.createRecord('bbabf9ae', component.options)
    } else {
      api.reload('bbabf9ae', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bbabf9ae&scoped=true&", function () {
      api.rerender('bbabf9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21G3p08TE0kFc/JS/comp/SearchFilterTokens.vue"
export default component.exports